import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import Barcode from "react-barcode";
import AppContext from "../../appContext";
import lenteProntaLogo from "../img/lente-pronta-logo.png";
import "../../pedido-atacado/pdf-order/pdf-order.css";

class PDFOrderLentePronta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      order: null,
      empresa_faturamento: "",
      useLocalData: false,
    };

    PDFOrderLentePronta.contextType = AppContext;
  }

  reactToPrintTrigger = () => {
    const { label, btn_class } = this.props;

    return (
      <Button id="btn-imprimir-pedido" className={btn_class ? btn_class : "pdf-button"} variant="link">
        {label ? label : "Visualizar Pedido"}
      </Button>
    );
  };

  handleOnBeforeGetContent = () => {
    if (this.props.pedidoId && this.props.produtos?.length) {
      return new Promise((resolve) => {
        this.setState({ useLocalData: true }, resolve);
      });
    }

    const { laboratorio, otica, pedido_laboratorio, redeOticas } = this.props;
    this.context.showLoading("");

    return new Promise((resolve) => {
      const body = {
        access_token: sessionStorage.getItem("token"),
        laboratorio: laboratorio,
        pedido_id: pedido_laboratorio,
      };

      if (redeOticas) {
        body.otica = otica;
      }

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      };

      fetch(
        process.env.REACT_APP_LABS_API + "sensidia/gestao_pedidos_laboratorios/lente_pronta_pedido.php",
        requestOptions,
      )
        .then(response => response.json())
        .then(json => {
          if (json && json.status && json.status !== 200) {
            this.context.hideLoading();
            Swal.fire({
              text: json.message?.mensagem || "Erro ao tentar recuperar as informações do pedido. Tente novamente mais tarde.",
              icon: "warning",
              title: "Aviso",
              confirmButtonColor: "#00518b",
              customClass: { confirmButton: "x-follow-order__filter-btn" },
            });
          } else if (json) {
            this.getEmpresaFaturamento(() => {
              this.setState({ order: json, id: json.id, useLocalData: false }, () => {
                this.context.hideLoading();
                resolve();
              });
            });
          }
        })
        .catch(() => {
          this.context.hideLoading();
          Swal.fire({
            text: "Erro ao tentar recuperar as informações do pedido. Tente novamente mais tarde.",
            icon: "warning",
            title: "Aviso",
            confirmButtonColor: "#00518b",
            customClass: { confirmButton: "x-follow-order__filter-btn" },
          });
        });
    });
  };

  getEmpresaFaturamento = (callback) => {
    const { otica } = this.props;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cnpj: otica ? otica : this.context.userSession.conta }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", requestOptions)
      .then(response => response.json())
      .then(json => {
        this.setState({ empresa_faturamento: json.nome }, callback);
      });
  };

  renderHeader(data) {
    const showValor = data.valorLiquido && this.context.userSession.modulos.includes("Pedidos Valores");

    return (
      <div className="pdf-order-header">
        <div className="row">
          <div className="col-6 text-left">
            <img src={lenteProntaLogo} width="178" height="120" alt="Logo Lente Pronta" />
          </div>
          <div className="col-6 text-end">
            <Barcode value={String(data.pedidoId)} height="70" text={"Nº do Pedido: " + data.pedidoId} />
          </div>
        </div>
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-6">
            <p className="pdf-subtitle" style={{ marginBottom: 0 }}>
              <b>Laboratório:</b> <br />
              {data.laboratorio_nome}
            </p>
          </div>
          {showValor && (
            <div className="col-6">
              <p className="pdf-subtitle" style={{ marginBottom: 0 }}>
                <b>Valor total do pedido:</b> <br />
                {parseFloat(data.valorLiquido).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderDados(data) {
    return (
      <div className="pdf-order-dados row">
        <div className="col-12">
          <h1 className="pdf-title">Dados do pedido</h1>
        </div>
        <div className="row">
          <div className="col">
            {data.voucherCodigo && (
              <div className="row pdf-span">
                <div className="col-3 text-left p-0">
                  <p className="float-left">Voucher Pacto</p>
                </div>
                <div className="col-8 text-end p-0">
                  <p className="float-end" style={{ wordBreak: "break-all" }}>{data.voucherCodigo}</p>
                </div>
              </div>
            )}
            <div className="row pdf-span">
              <div className="col-3 text-left p-0">
                <p className="float-left">Nº do pedido da ótica</p>
              </div>
              <div className="col-8 text-end p-0">
                <p className="float-end">{data.pedidoOtica || "-"}</p>
              </div>
            </div>
          </div>
          <div className="col">
            {data.voucherDescricao && (
              <div className="row pdf-span">
                <div className="col-3 text-left p-0">
                  <p className="float-left">Pilar Pacto</p>
                </div>
                <div className="col-8 text-end p-0">
                  <p className="float-end">{data.voucherDescricao}</p>
                </div>
              </div>
            )}
            <div className="row pdf-span">
              <div className="col-3 text-left p-0">
                <p className="float-left">Empresa de faturamento</p>
              </div>
              <div className="col-8 text-end p-0">
                <p className="float-end">{data.empresa_faturamento || "-"}</p>
              </div>
            </div>
            {data.codigoParticipante && (
              <div className="row pdf-span">
                <div className="col-3 text-left p-0">
                  <p className="float-left">Código do Participante</p>
                </div>
                <div className="col-8 text-end p-0">
                  <p className="float-end">{data.codigoParticipante}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderProduto(data) {
    return (
      <div className="pdf-order-dados row">
        <div className="col-12">
          <h1 className="pdf-title">Produto</h1>
        </div>
        <div className="row">
          <div className="col">
            <div className="row pdf-span">
              <div className="col-3 text-left p-0">
                <p className="float-left">Tipo de produção</p>
              </div>
              <div className="col-8 text-end p-0">
                <p className="float-end">Lente Pronta</p>
              </div>
            </div>
            <div className="row pdf-span">
              <div className="col-3 text-left p-0">
                <p className="float-left">Tipo de produto</p>
              </div>
              <div className="col-8 text-end p-0">
                <p className="float-end">Visão Simples</p>
              </div>
            </div>
            <div className="row pdf-span">
              <div className="col-3 text-left p-0">
                <p className="float-left">Produto escolhido</p>
              </div>
              <div className="col-8 text-end p-0">
                {data.produtosNomes.map((nome, indice) => (
                  <p className="float-end" style={{ clear: "both" }} key={indice}>{nome}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPrescricao(data) {
    const { showOD, showOE, prescricao_OD, prescricao_OE } = data;

    return (
      <div className="pdf-order-dados row">
        <div className="col-12">
          <h1 className="pdf-title">Prescrição</h1>
        </div>
        <div className="col-12">
          <p className="pdf-subtitle-bold">Receita</p>
        </div>
        {showOD && prescricao_OD && (
          <div className="row">
            <div className="col-12">
              <p className="pdf-subtitle-bold">Direito</p>
            </div>
            <div className="col">
              <div className="row pdf-span">
                <div className="col-3 text-left p-0">
                  <p className="float-left">Esférico</p>
                </div>
                <div className="col-8 text-end p-0">
                  <p className="float-end">{prescricao_OD.esferico || prescricao_OD.grauEsferico || "-"}</p>
                </div>
              </div>
              <div className="row pdf-span">
                <div className="col-3 text-left p-0">
                  <p className="float-left">Cilíndrico</p>
                </div>
                <div className="col-8 text-end p-0">
                  <p className="float-end">{prescricao_OD.cilindrico || prescricao_OD.grauCilindrico || "-"}</p>
                </div>
              </div>
              {(prescricao_OD.eixo !== undefined && prescricao_OD.eixo !== null && prescricao_OD.eixo !== "") && (
                <div className="row pdf-span">
                  <div className="col-3 text-left p-0">
                    <p className="float-left">Eixo</p>
                  </div>
                  <div className="col-8 text-end p-0">
                    <p className="float-end">{prescricao_OD.eixo}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {showOE && prescricao_OE && (
          <div className="row">
            <div className="col-12">
              <p className="pdf-subtitle-bold">Esquerdo</p>
            </div>
            <div className="col">
              <div className="row pdf-span">
                <div className="col-3 text-left p-0">
                  <p className="float-left">Esférico</p>
                </div>
                <div className="col-8 text-end p-0">
                  <p className="float-end">{prescricao_OE.esferico || prescricao_OE.grauEsferico || "-"}</p>
                </div>
              </div>
              <div className="row pdf-span">
                <div className="col-3 text-left p-0">
                  <p className="float-left">Cilíndrico</p>
                </div>
                <div className="col-8 text-end p-0">
                  <p className="float-end">{prescricao_OE.cilindrico || prescricao_OE.grauCilindrico || "-"}</p>
                </div>
              </div>
              {(prescricao_OE.eixo !== undefined && prescricao_OE.eixo !== null && prescricao_OE.eixo !== "") && (
                <div className="row pdf-span">
                  <div className="col-3 text-left p-0">
                    <p className="float-left">Eixo</p>
                  </div>
                  <div className="col-8 text-end p-0">
                    <p className="float-end">{prescricao_OE.eixo}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderObservacao(data) {
    if (!data.observacao) return null;

    return (
      <div className="pdf-order-armacao row">
        <div className="col-12">
          <h1 className="pdf-title">Dados adicionais</h1>
        </div>
        <div className="row pdf-order-dados-adicionais">
          <div className="col">
            <b>Observação</b>
            <br />
            <p>{data.observacao}</p>
          </div>
        </div>
      </div>
    );
  }

  renderFooter(data) {
    return (
      <div className="pdf-order-footer row">
        <div className="col-6 text-left">
          <p>
            O número do seu pedido no laboratório {data.laboratorio_nome} é{" "}
            <small>{data.pedidoId}</small>
          </p>
        </div>
        <div className="col-6 text-end">
          <p style={{ textAlign: "center" }}>
            A data de saída estimada é{" "}
            <small>{data.prazo}</small>
          </p>
        </div>
      </div>
    );
  }

  getDataFromProps() {
    const { prescricaoOlhos } = this.props;
    const pacto = this.props.pacto;
    const hasVoucher = pacto?.useVoucher && pacto?.selectedVoucher;

    return {
      pedidoId: this.props.pedidoId,
      pedidoOtica: this.props.pedidoOtica,
      laboratorio_nome: this.props.laboratorio_nome,
      labLogo: this.props.labLogo,
      empresa_faturamento: this.props.empresa_faturamento,
      codigoParticipante: this.props.codigoParticipante,
      produtosNomes: (this.props.produtos || []).map(produto => produto.descricao || produto.codigo || "-"),
      showOD: prescricaoOlhos === "ambos" || prescricaoOlhos === "direito",
      showOE: prescricaoOlhos === "ambos" || prescricaoOlhos === "esquerdo",
      prescricao_OD: this.props.prescricao_OD,
      prescricao_OE: this.props.prescricao_OE,
      observacao: this.props.observacao,
      prazo: this.props.prazo,
      valorLiquido: this.props.valorLiquido,
      voucherCodigo: hasVoucher ? pacto.selectedVoucher.codigo : "",
      voucherDescricao: hasVoucher ? (pacto.selectedVoucher.pilar || "") : "",
    };
  }

  getDataFromApi() {
    const order = this.state.order;
    const prescricao = order.prescricao || {};
    const olhoDireito = prescricao.olhoDireito || prescricao.OD;
    const olhoEsquerdo = prescricao.olhoEsquerdo || prescricao.OE;
    const cortesia = order.cortesia || {};

    return {
      pedidoId: order.id,
      pedidoOtica: order.idPedidoOtica,
      laboratorio_nome: this.props.laboratorio_nome,
      labLogo: this.props.labLogo,
      empresa_faturamento: this.state.empresa_faturamento,
      codigoParticipante: order.programaLaboratorio?.codigoParticipante,
      produtosNomes: Array.isArray(order.produtos) && order.produtos.length > 0
        ? order.produtos.map(produto => produto.descricao || produto.codigo || "-")
        : [order.produto?.descricao || order.produto?.codigo || "-"],
      showOD: !!olhoDireito,
      showOE: !!olhoEsquerdo,
      prescricao_OD: olhoDireito,
      prescricao_OE: olhoEsquerdo,
      observacao: order.observacao,
      prazo: this.props.prazo,
      valorLiquido: order.orcamento?.valorLiquido,
      voucherCodigo: cortesia.codigoVoucher || "",
      voucherDescricao: cortesia.descricao || "",
    };
  }

  render() {
    const isLocal = this.state.useLocalData;
    const hasData = isLocal || this.state.order;
    const data = hasData ? (isLocal ? this.getDataFromProps() : this.getDataFromApi()) : null;
    const docTitle = data ? data.pedidoId : this.props.pedidoId || this.props.pedido_laboratorio || "";

    return (
      <>
        <ReactToPrint
          documentTitle={`Essilor Conecta - Pedido ${docTitle}`}
          onBeforeGetContent={this.handleOnBeforeGetContent}
          trigger={this.reactToPrintTrigger}
          content={() => this.componentRef}
        />

        <div style={{ display: "none" }}>
          {data && (
            <div className="pdf-order container" ref={el => (this.componentRef = el)}>
              {this.renderHeader(data)}
              {this.renderDados(data)}
              {this.renderProduto(data)}
              {this.renderPrescricao(data)}
              {this.renderObservacao(data)}
              {this.renderFooter(data)}
            </div>
          )}
        </div>
      </>
    );
  }
}

export default PDFOrderLentePronta;
